import React from "react";

const WAVE_PATH =
  "M0,50 C150,100 450,0 600,50 C750,100 1050,0 1200,50 " +
  "C1350,100 1650,0 1800,50 C1950,100 2250,0 2400,50 L2400,200 L0,200 Z";

const layers = [
  {
    fill: "rgba(76, 45, 143, 0.45)",
    height: "55%",
    duration: "26s",
    direction: "normal",
  },
  {
    fill: "rgba(139, 92, 246, 0.3)",
    height: "40%",
    duration: "18s",
    direction: "reverse",
  },
  {
    fill: "rgba(251, 191, 36, 0.1)",
    height: "28%",
    duration: "13s",
    direction: "normal",
  },
];

export default function MantleWaves({ className = "" }) {
  return (
    <div
      className={`absolute inset-x-0 bottom-0 overflow-hidden pointer-events-none ${className}`}
      aria-hidden="true"
    >
      {layers.map((layer, index) => (
        <svg
          key={index}
          viewBox="0 0 2400 200"
          preserveAspectRatio="none"
          className="absolute bottom-0 left-0 mantle-wave"
          style={{
            width: "200%",
            height: layer.height,
            animationDuration: layer.duration,
            animationDirection: layer.direction,
          }}
        >
          <path d={WAVE_PATH} fill={layer.fill} />
        </svg>
      ))}
    </div>
  );
}
